import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import API from '../../../config/axios.config';
import { API_ENDPOINTS } from '../../../shared/api-endpoints';

export const ChangePasswordApi: any = createAsyncThunk('changePasswordApi', async (formData: any) => {
	try {
		const { data } = await API.post(API_ENDPOINTS.CHANGE_PASSWORD, formData);
		return data;
	} catch (changePassError: any) {
		return changePassError?.response?.data;
	}
});

const ChangePasswordSlice = createSlice({
	name: 'changePasswordApi',
	initialState: {
		changePassRes: [],
		changePassLoad: false,
		changePassError: ''
	},
	reducers: {
		reset: (state) => {
			state.changePassRes = [];
			state.changePassLoad = false;
			state.changePassError = '';
		}
	},
	extraReducers: (builder) => {
		builder.addCase(ChangePasswordApi.fulfilled, (state, action: any) => {
			state.changePassLoad = false;
			state.changePassRes = action.payload;
			state.changePassError = '';
		});

		builder.addCase(ChangePasswordApi.pending, (state) => {
			state.changePassLoad = true;
		});

		builder.addCase(ChangePasswordApi.rejected, (state, action: any) => {
			state.changePassLoad = false;
			state.changePassRes = [];
			state.changePassError = action.payload;
		});
	}
});

export const { reset: resetChangePassword } = ChangePasswordSlice.actions;
export const ChangePasswordApiSlice = ChangePasswordSlice.reducer;
